<template>
	<div v-if="orderList.length == 0"></div>
	<div class="pays" v-else>
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1rem" @click="back" />
			<span>订单支付</span>
			<div></div>
		</div>
		<!-- 修改地址 -->
		<div class="adress">
			<div class="top">
				<div>
					<van-icon name="location-o" style="font-size: 0.8rem; position: relative; top: 2px;" />
					<span>地址: {{orderList.province}}{{orderList.city}}{{orderList.area}}{{orderList.address}}</span>
				</div>
			</div>
			<div class="bottom">
				<span>{{orderList.real_name}}</span>
				<span>{{orderList.phone}}</span>
			</div>
		</div>
		<!-- 订单信息 -->
		<div class="order">
			<div class="list" v-for="item in orderList.order_second" @click="setParams(item.goods_id)">
				<van-card :num="item.num" :thumb="item.goods_image | handleUrl">
					<div slot="title" class="order_title">
						<div>{{item.goods_title}}</div>
					</div>

          <div slot="price">
          	<div v-if="orderList.lease_id == 6">买断金额¥{{item.price}}</div>
            <div v-else-if="orderList.lease_id == 7 || orderList.lease_id == 4 ">首年租金¥{{item.Lease_algorithm_price}}/月</div>
            <div v-else>首年租金¥{{item.Lease_algorithm_price}}/月</div>
          </div>

					<div slot="bottom" class="color_b2">
						<span>{{item.goods_spec_name}}</span>
					</div>
				</van-card>
			</div>
		</div>
		<!-- 详细费用 -->
		<div v-if="orderList.lease_id == 6">
			<van-cell class="msg">
				<div style="color: #000000; text-align: right; width: 100%;">
					<span style="color: #000;">需支付<span style="font-weight: bold; color: red;">买断金额总计￥{{(orderList.total-orderList.logistics_price).toFixed(2)}}</span>&nbsp;&nbsp;</span>
          <span style="color:red">运输安装费￥{{orderList.logistics_price}}</span>
				</div>
				<div slot="default" style="color: red; text-align: right; width: 100%;" >
					<span style="color: #b2b2b2;">市场购买指导含税价￥{{orderList.market_price}}</span>,为您节省￥<span style="color: #7dcd7c;">{{orderList.market_price-orderList.Lease_deposit_price}}</span></span>
				</div>
			</van-cell>
			<van-cell class="msg">
				<div slot="default" style="color: red;">

					<span class="color_f14" v-if="orderList.state == 0">等待付款</span>
					<span class="color_f14" v-else-if="orderList.state == 1">等待发货</span>
					<span class="color_f14" v-else-if="orderList.state == 2">等待收货</span>
					<span class="color_f14" v-else-if="orderList.state == 3">等待评价</span>
					<span class="color_f14" v-else-if="orderList.state == 4">已完成</span>
					<span class="color_f14" v-else-if="orderList.state == 5">已取消</span>
					<span class="color_f14" v-else>交易关闭</span>
				</div>
			</van-cell>
		</div>
		<div v-else-if="orderList.lease_id == 7 || orderList.lease_id == 4 ">
			<van-cell class="msg">
				<div slot="default" style="color: red;">
					<div style="color: #000000; text-align: right; width: 100%;">
						<span style="color: #000;">需支付<span style=" color: red; font-weight: bold;">首年租金￥{{orderList.Lease_deposit_price}}</span>&nbsp;&nbsp;</span>
						<span style="color:red;">运输安装费￥{{orderList.logistics_price}}</span>
					</div>
					<!-- <div style="color: #000000; text-align: right; width: 100%;">
						月支付租金¥{{orderList.Lease_month_one_price}}&nbsp;&nbsp;续租¥{{orderList.Lease_month_price}}/月
					</div> -->
					<div style="color: #b2b2b2; text-align: right; width: 100%;">
						市场购买参考含税价¥{{orderList.market_price}},为您节省￥<span style="color: #7dcd7c;">{{orderList.market_price-orderList.Lease_deposit_price}}</span></span>
					</div>
				</div>
			</van-cell>
			<van-cell class="msg">
				<div slot="default" style="color: red;">
					<span class="color_f14" v-if="orderList.state == 0">等待付款</span>
					<span class="color_f14" v-else-if="orderList.state == 1">等待发货</span>
					<span class="color_f14" v-else-if="orderList.state == 2">等待收货</span>
					<span class="color_f14" v-else-if="orderList.state == 3">等待评价</span>
					<span class="color_f14" v-else-if="orderList.state == 4">已完成</span>
					<span class="color_f14" v-else-if="orderList.state == 5">已取消</span>
					<span class="color_f14" v-else>交易关闭</span>
				</div>
			</van-cell>
			<van-cell class="msg">

			</van-cell>
		</div>
		<div v-else>
			<van-cell class="msg">
				<div slot="default" style="color: red;">
					<span style="color: red;">首年租金<span style="font-size: 1.15rem; color: red;">￥{{orderList.Lease_deposit_price}}</span>&nbsp;&nbsp;</span>
					<span style="color: red;">运输安装费￥{{orderList.logistics_price}}</span>
					<span class="color_f14" v-if="orderList.state == 0">等待付款</span>
					<span class="color_f14" v-else-if="orderList.state == 1">等待发货</span>
					<span class="color_f14" v-else-if="orderList.state == 2">等待收货</span>
					<span class="color_f14" v-else-if="orderList.state == 3">等待评价</span>
					<span class="color_f14" v-else-if="orderList.state == 4">已完成</span>
					<span class="color_f14" v-else-if="orderList.state == 5">已取消</span>
					<span class="color_f14" v-else>交易关闭</span>
				</div>
			</van-cell>
			<van-cell class="msg">
				<div slot="default" style="color: red;">
					<span style="color: #b2b2b2;">市场购买指导含税价￥{{orderList.market_price}},为您节省￥<span style="color: #7dcd7c;">{{orderList.market_price-orderList.Lease_deposit_price}}</span></span>
				</div>
			</van-cell>
		</div>

		<!-- 用户留言 -->
		<div class="message">
			<van-panel desc="描述信息">
				<div slot="header" class="message_header">
					<div>
						<span class="label">订单编号:</span>
						<span>{{orderList.order_number}}</span>
					</div>
					<div>
						<span class="label">下单时间:</span>
						<span>{{orderList.create_time}}</span>
					</div>
				</div>
				<div class="message_content">
					<van-cell-group>
						<van-field label-width="4.5rem" disabled v-model="message" rows="2" autosize label="用户留言" type="textarea"
						 placeholder="请输入留言" />
					</van-cell-group>
				</div>
			</van-panel>
		</div>
		<!-- 上传支付凭证 -->
		<div v-if="orderList.gateway==1 && orderList.payment_image==null">
			<van-panel title="上传付款凭证" class="main_upload">
				<div class="tips">请上传小于10M图纸及备注信息</div>
				<div slot="default" class="default">
					<van-uploader :after-read="subCamera" v-model="fileLists" :max-count="1" />
				</div>
			</van-panel>
		</div>
		<!-- 合同下载申请发票 -->
		<div style="display: flex; justify-content: space-between;" v-if="orderList.state == 1 && orderList.order_second[0].category_id==1">
			<div style="width: 50%;">
				<van-button round size="mini" style="width: 90%;" @click="tocontract(orderList.order_number,2)">合同下载</van-button>
			</div>
			<div style="width: 50%;">
				<van-button v-if="statelist.state==0" round size="mini" style="width: 90%;">发票审核中</van-button>
				<van-button v-else-if="statelist.state==1" round size="mini" style="width: 90%;" @click="download(statelist.url)">下载发票</van-button>
				<van-button v-else round size="mini" style="width: 90%;" @click="goorder(orderList.id,orderList.order_number)">申请发票</van-button>
			</div>
		</div>
		<div style="display: flex; justify-content: space-between;" v-if="orderList.state == 0 && orderList.order_second[0].category_id==1">
			<div style="width: 93%; margin: auto; margin-bottom: 1rem;">
				<van-button size="mini" style=" width: 100%; " round @click="tocontract(orderList.order_number,1)">合同下载</van-button>
			</div>
		</div>

		<!-- 支付方式 -->
		<van-popup v-model="show" position="bottom">
			<van-panel class="payment">
				<div slot="header" class="payment_header">
					支付方式
				</div>
				<div class="payment_content">
					<van-radio-group v-model="radio1">
						<van-cell-group>
							<van-cell title="微信" clickable @click="radio='1'">
								<div slot="icon" class="payment_icon">
									<img src="../../assets/wx.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="1" />
							</van-cell>
							<van-cell title="支付宝" clickable @click="radio='2'">
								<div slot="icon" class="payment_icon">
									<img src="../../assets/zfb.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" slot="right-icon" name="2" />
							</van-cell>
							<!-- 							<van-cell title="银行卡" clickable @click="radio='3'">
								<div slot="icon" class="payment_icon">
									<img src="../../assets/yl.png" alt="">
								</div>
								<van-radio checked-color="#F1452F" icon-size="1rem" disabled slot="right-icon" name="3" />
							</van-cell> -->
						</van-cell-group>
					</van-radio-group>
					<div class="pays_btn">
						<!-- 					<button class="left-button" @click="duig=true">对公转账</button> -->
						<button class="right-button" @click="submit">立即付款</button>
					</div>
				</div>
			</van-panel>
		</van-popup>
		<!-- 底部按钮 -->
		<div class="btn btn_order" v-if="orderList.state == 0">
			<span class="color_f14">合计¥{{orderList.total}}</span>
			<div style="width: 60%; display: flex; justify-content: space-between;">
				<van-button v-if="orderList.payment_image==null||orderList.gateway!=1" round size="mini" @click="showPopup(orderList.id)">取消订单</van-button>
				<van-button v-if="orderList.gateway==1 && orderList.payment_image==null" color="#f1452f" round size="small" @click="getvoucher">提交</van-button>
				<van-button v-else-if="orderList.gateway==1 && orderList.payment_image!=null" color="#f1452f" round size="small"
				 style="width: 100%;">审核中</van-button>
				<van-button v-else color="#f1452f" round size="small" @click="show = true">去支付</van-button>
			</div>
		</div>
		<div class="btn btn_order" v-if="orderList.state == 1">
			<span class="color_f14">合计¥{{orderList.total}}</span>
			<van-button round size="mini" @click="open53">提醒发货</van-button>
		</div>
		<div class="btn btn_order" v-if="orderList.state == 2">
			<span class="color_f14">合计¥{{orderList.total}}</span>
			<van-button round size="mini" color="#F1452F" @click="cancel(3, orderList.id,orderList.order_number)" plain>确认收货</van-button>
		</div>
		<div class="btn btn_order" v-if="orderList.state == 3">
			<span class="color_f14">合计¥{{orderList.total}}</span>
			<van-button round size="mini" color="#F1452F" plain @click="evaluate(orderList.order_number)">评价
			</van-button>
		</div>
		<div class="btn btn_order" v-if="orderList.state == 4">
			<span class="color_f14">合计¥{{orderList.total}}</span>
			<van-button round size="mini">查看发票</van-button>
		</div>
		<div class="btn btn_order" v-if="orderList.state == 5">
			<span class="color_f14">合计¥{{orderList.total}}</span>
			<!-- 			<div style="width: 60%; display: flex; justify-content: space-between;"> -->
			<van-button round size="mini" @click="delOrder(orderList.id, orderList.order_number)">删除订单</van-button>
			<!-- 				<van-button round size="mini" @click="Buyagain(orderList.order_number)" color="#F1452F" plain>再次购买</van-button> -->
			<!-- 			</div> -->
		</div>
		<!-- 取消订单 -->
		<van-popup v-model="cancels" position="bottom" class="cancel">
			<div class="cancel_title">请选择取消订单的原因(必选):</div>
			<van-radio-group v-model="cancel_radio" @change="radios">
				<van-cell-group>
					<van-cell title="不想要了" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="不想要了" />
					</van-cell>
					<van-cell title="商品信息填写错误" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="商品信息填写错误" />
					</van-cell>
					<van-cell title="地址信息填写错误" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="地址信息填写错误" />
					</van-cell>
					<van-cell title="其他" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="其他" />
					</van-cell>
				</van-cell-group>
			</van-radio-group>
			<div class="cancel_btn">
				<button @click="cancel(5)">提交</button>
			</div>
		</van-popup>

		<!-- 对公转账 -->
		<!-- 		<van-popup v-model="duig" class="duig" position="bottom">
			<div class="duig-top">对公账户</div>
			<van-cell size="large">
				<div slot="title" class="duig-title">
					<div>开户名称：</div>
					<div>广州俱百家网络科技有限公司</div>
				</div>
			</van-cell>
			<van-cell size="large">
				<div slot="title" class="duig-title">
					<div>开户账户：</div>
					<div>3602073809100114062</div>
				</div>
			</van-cell>
			<van-cell size="large">
				<div slot="title" class="duig-title">
					<div>开户银行：</div>
					<div>中国工商银行广州泰沙路支行</div>
				</div>
			</van-cell>
			<div class="duig-foot">如果您打款成功，请联系客服 400-8722-000</div>
			<div class="duig-btn">
				<van-button round size="small" @click="duig=false" style="  border: 1px solid #eee;">取消</van-button>
				<van-button round color="#f1452f" size="small" @click="gateway" style=" border: 1px solid #f1452f;">确认</van-button>
			</div>
		</van-popup> -->
	</div>
</template>

<script>
	import Customerservice from '@/components/customerservice'

	export default {
		inject: ['reload'],
		data() {
			return {
				message: '',
				radio1: '1',
				show: false,
				cancels: false,
				cancel_radio: '不想要了',
				cancelId: -1,
				orderList: [],
				radio: '不想要了',
				duig: false,
				annex: [], //附件列表,
				fileLists: [],
				statelist: '',
				texta: false,
			}
		},
		created() {
			this.$axios.post(baseUrl + '/mobile/Order/orderInfo', {
				order_number: this.$route.query.order_number
			}).then((res) => {
				if (res.data.code == 2) {
					this.orderList = res.data.data;
					this.message = res.data.data.order_message;
					this.orderCode = res.data.data.order_number;
					// this.orderList.indexs = res.data.data.order_second[0].goods_spec_name.split(",")[1]
					// this.orderList.yueshu = parseFloat(this.orderList.indexs) / 2
					this.orderList.arrlist = res.data.data.Lease_month_one_price * this.orderList.yueshu
				}
				this.getInvoicestatus()
			}).catch((err) => {
				console.log(err);
			});
		},
		components: {
			Customerservice,
		},
		methods: {
			// 获取发票状态
			getInvoicestatus() {
				this.$axios.post(baseUrl + '/mobile/Bill/download', {
					order_id: this.orderList.id,
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					this.statelist = res.data.data
				})
			},
			submit() {
				if (this.radio1 == '1') {
					window.location.href = baseUrl + '/mobile/Pay/wapWxPay?out_trade_no=' + this.orderCode
				} else if (this.radio1 == '2') {
					window.location.href = baseUrl + '/mobile/Pay/wapPay?out_trade_no=' + this.orderCode
				} else {
					this.$toast('暂不支持');
				}
			},
			//跳转详情页
			setParams(em) {
				this.$router.push({
					path: '/Detail',
					query: {
						id: em
					}
				})
			},
			// 对公转账订单提交
			gateway() {
				this.$axios.post(baseUrl + '/mobile/Order/addOneOrder', {
					address_id: this.defaultAddress.id,
					is_channel: this.radio,
					order_message: this.message,
					goods_id: this.orderList.goods.id,
					combination_id: this.orderList.goods_spec_combination.id,
					num: this.num,
					lease_id: this.$route.query.typeId,
					logistics_price: this.logisticsPrice,
					category_id: this.orderList.goods.category_id,
					token: localStorage.getItem('Authorization'),
					gateway: 1,
				}).then((res) => {
					if (res.data.code == 19) {
						this.$toast("提交成功");
					}
				})
			},
			//取消弹框
			showPopup(id) {
				this.cancels = true;
				this.cancelId = id;
			},

			//确认收货
			cancel(data, id, ddh) {
				var that = this;
				var obj = {};
				if (data == 5) {
					this.$dialog.confirm({
							title: '确定取消订单',
						})
						.then(() => {
							obj.id = that.cancelId;
							obj.state = data;
							obj.cancel_message = that.radio;
							that.$axios.post(baseUrl + '/mobile/Order/updateOrder', obj).then((res) => {
								that.show = false
								if (res.data.code == 1) {
									that.$toast(res.data.msg);
									that.$router.push({
										path: '/order',
										query: {
											index: 0
										}
									})
									this.$axios.post(baseUrl + '/mobile/Order/order', {
										state: 0,
										token: localStorage.getItem('Authorization')
									}).then((res) => {
										if (res.data.code == 2) {
											this.orderList = res.data.data;
										} else {
											this.orderList = []
										}
									}).catch((err) => {
										console.log(err);
									})
								} else {
									that.$toast(res.data.msg);
									that.$router.push({
										path: '/assess',
										query: {
											id: ddh
										}
									})
								}
							}).catch((err) => {
								console.log(err);
							})
						})
						.catch(() => {
							// on cancel
						});

				} else {
					this.$dialog.confirm({
							title: '确定取消订单',
						})
						.then(() => {
							obj.id = id;
							obj.state = data;
							that.$axios.post(baseUrl + '/mobile/Order/updateOrder', obj).then((res) => {
								that.show = false
								if (res.data.code == 1) {
									that.$toast(res.data.msg);
									that.$router.push({
										path: '/order',
										query: {
											index: 0
										}
									})
									this.$axios.post(baseUrl + '/mobile/Order/order', {
										state: 0,
										token: localStorage.getItem('Authorization')
									}).then((res) => {
										if (res.data.code == 2) {
											this.orderList = res.data.data;
										} else {
											this.orderList = []
										}
									}).catch((err) => {
										console.log(err);
									})
								} else {
									that.$toast(res.data.msg);
									that.$router.push({
										path: '/assess',
										query: {
											id: ddh
										}
									})
								}
							}).catch((err) => {
								console.log(err);
							})
						})
						.catch(() => {
							// on cancel
						});
				}
			},
			// 再次购买
			// Buyagain(em){
			// 	this.$axios.post(baseUrl + '/mobile/Order/nextBuy', {
			// 		order_number:em,
			// 		token: localStorage.getItem('Authorization')
			// 	}).then(res=>{
			// 		window.location.href = '/orderDetail?order_number='+em
			// 	})
			// },
			//评价
			evaluate(idx) {
				this.$router.push({
					path: '/assess',
					query: {
						id: idx
					}
				})
			},
			// 合同下载
			tocontract(e, i) {
				this.$axios.post(baseUrl + '/mobile/order/contract', {
					order_number: this.orderList.order_number,
					token: localStorage.getItem('Authorization'),
					type: i
				}).then(res => {
					if (res.data.data == "yes") {
						this.$router.push({
							path: '/mycontract',
						})
					} else {
						this.$dialog.confirm({
								title: '您还没有填写您的合同信息',
								confirmButtonText: '去填写',
								confirmButtonColor: '#F1452F',
							})
							.then(() => {
								this.$router.push({
									path: '/contract',
									query: {
										order_number: e
									}
								})
							})
							.catch(() => {
								// on cancel
							});
					}
				});
			},
			//上传图片附件
			subCamera(file) {
				var that = this;
				let content = file.file;
				let data = new FormData();
				data.append('file', content);
				that.$axios.post(baseUrl + '/mobile/Index/imgUpload', data, {
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					if (res.data.code == 11) {
						that.$toast(res.data.msg);
						that.annex.push(res.data.data);
					}
				}).catch(function(err) {
					console.log(err);
				})
			},

			// 提交凭证图片
			getvoucher() {
				var that = this;
				that.$axios.post(baseUrl + '/mobile/Order/payment', {
					order_number: this.orderList.order_number,
					payment_image: this.annex[0],
					token: localStorage.getItem('Authorization')
				}).then(res => {
					that.$toast("提交成功");
					location.reload()
				}).catch((err) => {
					console.log(err);
				})
			},
			// 下载文件
			download(urle) {
				BSL.OpenWeb(urle)
			},
			//删除订单
			delOrder(id, num) {
				var that = this;
				that.$dialog.confirm({
					title: '确认删除订单',
				}).then(() => {
					that.$axios.post(baseUrl + '/mobile/Order/deleteOrder', {
						id: id,
						order_number: num
					}).then(function(res) {
						if (res.data.code == 9) {
							that.$toast(res.data.msg);
							setTimeout(function() {
								that.$router.push({
									path: '/order',
									query: {
										index: 0
									}
								})
							}, 1000);
						}
					}).catch(function(err) {
						console.log(err);
					})
				}).catch(() => {
					// on cancel
				});
			},
			//选择原因
			radios(name) {
				this.message = name;
			},
			// 申请发票
			goorder(e, i) {
				this.$router.push({
					path: '/overinvoices',
					query: {
						applyinvoice: e,
						jump: i
					}
				})
			},
		}
	}
</script>

<style scoped>
	@import 'orderDetails.css';

	.main_upload .tips {
		font-size: 12px;
		margin-top: 5px;
	}

	.main_upload .default {
		margin: 4px 0;
		padding: 14px 0;
	}

	.download {
		width: 100%;
		font-size: 12px;
		color: #000000;
		background-color: #fff;
		text-align: center;
		margin: auto;
		padding: 0.5rem 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/min/orderDetails.vue